import axios from "axios";
// const host = "https://staging.megahtex.com/admin/";
const host = process.env.REACT_APP_API_URL || "https://megahtex.com/admin/";
const access_endpoint_link = host + "API/";

const format_request = (postparam) => {
  if (postparam) {
    let token = window.localStorage.getItem("token");
    if (token) {
      postparam["token"] = token;
    }
  }
  let body = "";
  for (let k in postparam) {
    if (postparam[k] !== null && postparam[k] !== undefined) {
      body += encodeURI(k) + "=" + encodeURI(postparam[k]) + "&";
    }
  }
  var postOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
  };
  return postOptions;
};

const api_post = async (postparam = {}, end_point) => {
  var response = await fetch(
    access_endpoint_link + end_point,
    format_request(postparam)
  );
  var json = await response.json();
  return json;
};

export const admin_login = async (postparam) => {
  return api_post(postparam, "admin_login");
};
export const get_sales_order = async (postparam) => {
  return api_post(postparam, "get_sales_order");
};

export const get_orders_detail = async (postparam) => {
  return api_post(postparam, "get_orders_detail");
};

export const get_customer = async (postparam) => {
  return api_post(postparam, "get_customer");
};

export const get_customer_detail = async (postparam) => {
  return api_post(postparam, "get_customer_detail");
};

export const get_admin = async (postparam) => {
  return api_post(postparam, "get_admin");
};

export const get_admin_detail = async (postparam) => {
  return api_post(postparam, "get_admin_detail");
};

export const get_inventory = async (postparam) => {
  return api_post(postparam, "get_inventory");
};

export const get_inventory_detail = async (postparam) => {
  return api_post(postparam, "get_inventory_detail");
};

export const edit_address_admin = async (postparam) => {
  return api_post(postparam, "edit_address_admin");
};

export const delete_address = async (postparam) => {
  return api_post(postparam, "delete_address");
};

export const add_address_admin = async (postparam) => {
  return api_post(postparam, "add_address_admin");
};

export const get_orders_history_admin = async (postparam) => {
  return api_post(postparam, "get_orders_history_admin");
};

export const get_customer_contact = async (postparam) => {
  return api_post(postparam, "get_customer_contact");
};

export const get_inventory_by_customer = async (postparam) => {
  return api_post(postparam, "get_inventory_by_customer");
};

export const create_orders_admin = async (postparam) => {
  return api_post(postparam, "create_orders_admin");
};

export const orders_edit_item = async (postparam) => {
  return api_post(postparam, "orders_edit_item");
};

export const orders_remove_item = async (postparam) => {
  return api_post(postparam, "orders_remove_item");
};

export const orders_add_item = async (postparam) => {
  return api_post(postparam, "orders_add_item");
};

export const approve_order = async (postparam) => {
  return api_post(postparam, "approve_order");
};

export const reject_order = async (postparam) => {
  return api_post(postparam, "reject_order");
};

export const dashboard = async (postparam) => {
  return api_post(postparam, "dashboard");
};

export const replace_image = async (postparam) => {
  return api_post(postparam, "replace_image");
};

export const get_sales_order_report = async (postparam) => {
  return api_post(postparam, "get_sales_order_report");
};

export const get_sales_order_report_detail = async (postparam) => {
  return api_post(postparam, "get_sales_order_report_detail");
};

export const update_sales_order_report = async (postparam) => {
  return api_post(postparam, "update_sales_order_report");
};

export const get_shipping_charge = async (postparam) => {
  return api_post(postparam, "get_shipping_charge");
};

export const add_shipping_charge = async (postparam) => {
  return api_post(postparam, "add_shipping_charge");
};

export const edit_shipping_charge = async (postparam) => {
  return api_post(postparam, "edit_shipping_charge");
};

export const delete_shipping_charge = async (postparam) => {
  return api_post(postparam, "delete_shipping_charge");
};

export const get_report_reason = async (postparam) => {
  return api_post(postparam, "get_report_reason");
};

export const submit_return_report = async (postparam) => {
  return api_post(postparam, "submit_return_report");
};

export const get_customer_return = async (postparam) => {
  return api_post(postparam, "get_customer_return");
};

export const approve_consignment = async (postparam) => {
  return api_post(postparam, "approve_consignment");
};

export const validate_cart_admin = async (postparam) => {
  return api_post(postparam, "validate_cart_admin");
};

export const get_paymenttype = async (postparam) => {
  return api_post(postparam, "get_paymenttype");
};

export const get_brand = async (postparam) => {
  return api_post(postparam, "get_brand");
};

export const get_type = async (postparam) => {
  return api_post(postparam, "get_type");
};

export const get_class = async (postparam) => {
  return api_post(postparam, "get_class");
};

export const get_category = async (postparam) => {
  return api_post(postparam, "get_category");
};

export const get_shipping_country = async (postparam) => {
  return api_post(postparam, "get_shipping_country");
};

export const edit_shipping_country = async (postparam) => {
  return api_post(postparam, "edit_shipping_country");
};

export const get_custom_made = async (postparam) => {
  return api_post(postparam, "get_custom_made");
};

export const delete_custom_made = async (postparam) => {
  return api_post(postparam, "delete_custom_made");
};

export const change_admin_password = async (postparam) => {
  return api_post(postparam, "change_admin_password");
};

export const delete_item_image = async (postparam) => {
  return api_post(postparam, "delete_item_image");
};

export const get_shipping_method_admin = async (postparam) => {
  return api_post(postparam, "get_shipping_method_admin");
};

export const approve_deposit = async (postparam) => {
  return api_post(postparam, "approve_deposit");
};

export const get_sales_rep = async (postparam) => {
  return api_post(postparam, "get_sales_rep");
};

export const get_merchandiser = async (postparam) => {
  return api_post(postparam, "get_merchandiser");
};

export const update_merchandiser = async (postparam) => {
  return api_post(postparam, "update_merchandiser");
};

export const upsert_brand = async (postparam) => {
  return api_post(postparam, "upsert_brand");
};

export const edit_order = async (postparam) => {
  return api_post(postparam, "edit_order");
};

export const get_banner = async (postparam) => {
  return api_post(postparam, "get_banner");
};

export const add_banner = async (postparam) => {
  return api_post(postparam, "add_banner");
};

export const edit_banner = async (postparam) => {
  return api_post(postparam, "edit_banner");
};

export const delete_banner = async (postparam) => {
  return api_post(postparam, "delete_banner");
};

export const manual_create_sales_order = async (postparam) => {
  return api_post(postparam, "manual_create_sales_order");
};

export const get_contact_us = async (postparam) => {
  return api_post(postparam, "get_contact_us");
};

export const get_pending_order = async (postparam) => {
  return api_post(postparam, "get_pending_order");
};

export const get_role = async (postparam) => {
  return api_post(postparam, "get_role");
};

export const process_order_admin = async (postparam) => {
  return api_post(postparam, "process_order_admin");
};

export const edit_admin_role = async (postparam) => {
  return api_post(postparam, "edit_admin_role");
};

export const get_color = async (postparam) => {
  return api_post(postparam, "get_color");
};

export const add_color = async (postparam) => {
  return api_post(postparam, "add_color");
};

export const edit_color = async (postparam) => {
  return api_post(postparam, "edit_color");
};

export const delete_color = async (postparam) => {
  return api_post(postparam, "delete_color");
};

export const get_material = async (postparam) => {
  return api_post(postparam, "get_material");
};

export const add_material = async (postparam) => {
  return api_post(postparam, "add_material");
};

export const edit_material = async (postparam) => {
  return api_post(postparam, "edit_material");
};

export const delete_material = async (postparam) => {
  return api_post(postparam, "delete_material");
};

export const get_apparel = async (postparam) => {
  return api_post(postparam, "get_apparel");
};

export const add_apparel = async (postparam) => {
  return api_post(postparam, "add_apparel");
};

export const edit_apparel = async (postparam) => {
  return api_post(postparam, "edit_apparel");
};

export const delete_apparel = async (postparam) => {
  return api_post(postparam, "delete_apparel");
};

export const get_decoration = async (postparam) => {
  return api_post(postparam, "get_decoration");
};

export const add_decoration = async (postparam) => {
  return api_post(postparam, "add_decoration");
};

export const edit_decoration = async (postparam) => {
  return api_post(postparam, "edit_decoration");
};

export const delete_decoration = async (postparam) => {
  return api_post(postparam, "delete_decoration");
};

export const get_decorative = async (postparam) => {
  return api_post(postparam, "get_decorative");
};

export const add_decorative = async (postparam) => {
  return api_post(postparam, "add_decorative");
};

export const edit_decorative = async (postparam) => {
  return api_post(postparam, "edit_decorative");
};

export const delete_decorative = async (postparam) => {
  return api_post(postparam, "delete_decorative");
};

export const on_hold_listing = async (postparam) => {
  return api_post(postparam, "on_hold_listing");
};

export const get_country = async (postparam) => {
  return api_post(postparam, "get_country");
};

export const get_customer_cart = async (postparam) => {
  return api_post(postparam, "get_customer_cart");
};

export const save_customer_cart = async (postparam) => {
  return api_post(postparam, "save_customer_cart");
};

export const calculate_discount = async (postparam) => {
  return api_post(postparam, "calculate_discount");
};

export const add_shipping_state = async (postparam) => {
  return api_post(postparam, "add_shipping_state");
};

export const edit_shipping_state = async (postparam) => {
  return api_post(postparam, "edit_shipping_state");
};

export const delete_shipping_state = async (postparam) => {
  return api_post(postparam, "delete_shipping_state");
};

export const get_state = async (postparam) => {
  return api_post(postparam, "get_state");
};

export const get_status = async (postparam) => {
  return api_post(postparam, "get_status");
};

export const get_color_name = async (postparam) => {
  return api_post(postparam, "get_color_name");
};

export const get_razer_log = async (postparam) => {
  return api_post(postparam, "get_razer_log");
};

export const get_topup_history = async (postparam) => {
  return api_post(postparam, "get_topup_history");
};

export const superadmin_change_password = async (postparam) => {
  return api_post(postparam, "superadmin_change_password");
};

export const payment_link = async (postparam) => {
  return api_post(postparam, "payment_link");
};

export const get_customer_invoice = async (postparam) => {
  return api_post(postparam, "get_customer_invoice");
};

export const print_sales_order = async (postparam) => {
  return api_post(postparam, "print_sales_order");
};

export const print_summary = async (postparam) => {
  return api_post(postparam, "print_summary");
};

export const validate_state = async (postparam) => {
  return api_post(postparam, "validate_state");
};

export const get_customer_credit_note = async (postparam) => {
  return api_post(postparam, "get_customer_credit_note");
};

export const get_upload_file = (postparam) => {
  return axios.post(access_endpoint_link + "get_upload_file", postparam);
};

export const upload_item_images = (postparam) => {
  return axios.post(access_endpoint_link + "upload_item_images", postparam);
};

export const bulk_order_admin = (postparam) => {
  return axios.post(access_endpoint_link + "bulk_order_admin", postparam);
};

export const output_echo = (postparam) => {
  return axios.post(access_endpoint_link + "output_echo", postparam);
};

export const get_syn_log = (postparam) => {
  return api_post(postparam, "get_syn_log");
};

export const get_return_syn_log = (postparam) => {
  return api_post(postparam, "get_return_syn_log");
};

export const close_order = (postparam) => {
  return api_post(postparam, "close_order");
};

export const reject_report = (postparam) => {
  return api_post(postparam, "reject_report");
};

export const get_return_status = (postparam) => {
  return api_post(postparam, "get_return_status");
};

export const get_price_level = (postparam) => {
  return api_post(postparam, "get_price_level");
};

export const update_sales_order_shipping = (postparam) => {
  return api_post(postparam, "update_sales_order_shipping");
};

export const get_shipping_method = (postparam) => {
  return api_post(postparam, "get_shipping_method");
};

export const get_shipping_carrier_by_id = (postparam) => {
  return api_post(postparam, "get_shipping_carrier_by_id");
};

export const get_address = (postparam) => {
  return api_post(postparam, "get_address");
};

export const manual_post_order = (postparam) => {
  return api_post(postparam, "manual_post_order");
};

export const manual_close_order = (postparam) => {
  return api_post(postparam, "manual_close_order");
};

export const manual_update_attachment = (postparam) => {
  return api_post(postparam, "manual_update_attachment");
};

export const manual_change_shipping = (postparam) => {
  return api_post(postparam, "manual_change_shipping");
};

export const manual_customer_return = (postparam) => {
  return api_post(postparam, "manual_customer_return");
};

export const manual_customer_return_order = (postparam) => {
  return api_post(postparam, "manual_customer_return_order");
};

export const get_inventory_by_customer_children = (postparam) => {
  return api_post(postparam, "get_inventory_by_customer_children");
};

export const manual_customer_payment = (postparam) => {
  return api_post(postparam, "manual_customer_payment ");
};

export const reset_password_with_key = (postparam) => {
  return api_post(postparam, "reset_password_with_key ");
};

export const delete_contact_us = (postparam) => {
  return api_post(postparam, "delete_contact_us ");
};

export const get_statement = (postparam) => {
  return api_post(postparam, "get_statement");
};

export const get_sales_rep_report = (postparam) => {
  return api_post(postparam, "get_sales_rep_report");
};

export const get_customer_report_data = (postparam) => {
  return api_post(postparam, "get_customer_report_data");
};

export const add_title = (postparam) => {
  return api_post(postparam, "add_title ");
};

export const edit_title = (postparam) => {
  return api_post(postparam, "edit_title ");
};

export const delete_title = (postparam) => {
  return api_post(postparam, "delete_title ");
};

export const get_best_seller_list = (postparam) => {
  return api_post(postparam, "get_best_seller_list");
};

export const get_best_seller_detail = (postparam) => {
  return api_post(postparam, "get_best_seller_detail ");
};

export const add_product_slider = (postparam) => {
  return api_post(postparam, "add_product_slider ");
};

export const edit_product_slider = (postparam) => {
  return api_post(postparam, "edit_product_slider ");
};

export const delete_product_slider = (postparam) => {
  return api_post(postparam, "delete_product_slider ");
};
